/*
 * DRV "Ofte købt sammen"
 * Henter produktanbefalinger (intent=complementary, fallback related),
 * viser dem med afkrydsning + samlet pris og lægger de valgte i kurven.
 */
(function () {
  var box = document.querySelector('.drv-fbt');
  if (!box) return;

  var productId = box.getAttribute('data-product-id');
  var baseUrl = box.getAttribute('data-url') || '/recommendations/products';
  var listEl = box.querySelector('.drv-fbt__list');
  var totalEl = box.querySelector('[data-fbt-total]');
  var addBtn = box.querySelector('[data-fbt-add]');
  var addLabel = box.querySelector('[data-fbt-add-label]');
  var LIMIT = 3;

  function money(cents) {
    // dansk format: 1.234,00 kr.
    var v = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!,))/g, '.');
    return v + ' kr.';
  }

  function url(intent) {
    return baseUrl + '?section_id=&product_id=' + productId +
      '&limit=' + LIMIT + '&intent=' + intent;
  }

  function fetchJson(intent) {
    return fetch(url(intent).replace('/recommendations/products?', '/recommendations/products.json?'))
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .catch(function () { return { products: [] }; });
  }

  function firstAvailableVariant(p) {
    if (!p.variants || !p.variants.length) return null;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].available) return p.variants[i];
    }
    return p.variants[0];
  }

  var EYE = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true">' +
    '<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" stroke="currentColor" stroke-width="1.6"/>' +
    '<circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.6"/></svg>';

  function render(products) {
    if (!products || !products.length) return; // forbliver skjult
    var rows = '';
    var idx = 0;
    products.slice(0, LIMIT).forEach(function (p) {
      var v = firstAvailableVariant(p);
      if (!v) return;
      var img = (p.featured_image || (p.images && p.images[0]) || '');
      if (img && img.indexOf('//') === 0) img = 'https:' + img;
      var purl = p.url || ('/products/' + p.handle);
      rows += '' +
        '<div class="drv-fbt__item">' +
          '<label class="drv-fbt__pick">' +
            '<input type="checkbox" class="drv-fbt__check"' + (idx === 0 ? ' checked' : '') +
              ' data-variant-id="' + v.id + '" data-price="' + v.price + '">' +
            '<img class="drv-fbt__thumb" src="' + img + '&width=120" alt="" loading="lazy">' +
            '<span class="drv-fbt__info">' +
              '<span class="drv-fbt__name">' + p.title + '</span>' +
              '<span class="drv-fbt__price">' + money(v.price) + '</span>' +
            '</span>' +
          '</label>' +
          '<a class="drv-fbt__view" href="' + purl + '" aria-label="Se produktside" title="Se produktside">' + EYE + '</a>' +
        '</div>';
      idx++;
    });
    if (!rows) return;
    listEl.innerHTML = rows;
    box.hidden = false;
    updateTotal();
    listEl.addEventListener('change', updateTotal);
    placeFbt();
  }

  function checkedInputs() {
    return Array.prototype.slice.call(box.querySelectorAll('.drv-fbt__check:checked'));
  }

  function updateTotal() {
    var checked = checkedInputs();
    var sum = checked.reduce(function (a, el) { return a + parseInt(el.getAttribute('data-price'), 10); }, 0);
    totalEl.textContent = money(sum);
    addBtn.disabled = checked.length === 0;
    addLabel.textContent = checked.length > 0
      ? 'Læg ' + checked.length + (checked.length === 1 ? ' vare' : ' varer') + ' i kurv'
      : 'Vælg mindst én vare';
  }

  function addToCart() {
    var checked = checkedInputs();
    if (!checked.length) return;
    var items = checked.map(function (el) {
      return { id: parseInt(el.getAttribute('data-variant-id'), 10), quantity: 1 };
    });
    addBtn.disabled = true;
    addLabel.textContent = 'Lægger i kurv…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        addLabel.textContent = 'Lagt i kurv ✓';
        // åbn cart-drawer hvis temaet har en
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          drawer.open();
        } else {
          window.location.href = '/cart';
        }
        setTimeout(updateTotal, 1500);
      })
      .catch(function () {
        addLabel.textContent = 'Prøv igen';
        addBtn.disabled = false;
      });
  }

  addBtn.addEventListener('click', addToCart);

  // --- Placering: på mobil flyttes "Ofte købt sammen" ned under "Om produktet" ---
  var originalParent = box.parentNode;
  var originalNext = box.nextSibling;
  function placeFbt() {
    var lower = document.querySelector('.drv-media-lower');
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (isMobile && lower) {
      if (box.previousElementSibling !== lower) {
        lower.parentNode.insertBefore(box, lower.nextSibling);
      }
    } else if (box.parentNode !== originalParent) {
      originalParent.insertBefore(box, originalNext);
    }
  }
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(placeFbt, 150);
  });

  // Hent complementary; hvis tom, brug related
  fetchJson('complementary').then(function (data) {
    if (data.products && data.products.length) { render(data.products); }
    else { fetchJson('related').then(function (d2) { render(d2.products); }); }
  });
})();
